import React from "react"

const Close = props => (
  <svg viewBox="0 0 80 79.95" {...props}>
    <path d="M46.79 39.95L78.6 8.14a4.81 4.81 0 000-6.79 4.93 4.93 0 00-6.79 0L40 33.16 8.19 1.35a4.92 4.92 0 00-6.79 0 4.8 4.8 0 000 6.79l31.8 31.81L1.4 71.76a4.8 4.8 0 000 6.78 4.91 4.91 0 006.79 0L40 46.73l31.81 31.81a4.8 4.8 0 106.79-6.78z" />
  </svg>
)

export default Close
